(() => {
  const init = (popup) => {
    if (!popup || popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';
    const key = popup.dataset.sessionKey || 'laia-newsletter-popup';
    const designMode = Boolean(window.Shopify && Shopify.designMode);
    let seen = false;
    try { seen = sessionStorage.getItem(key) === 'seen'; } catch (_) {}
    if (seen && !designMode) return;

    const close = () => {
      popup.hidden = true;
      document.documentElement.classList.remove('laia-popup-open');
    };
    const open = () => {
      popup.hidden = false;
      document.documentElement.classList.add('laia-popup-open');
      try { sessionStorage.setItem(key, 'seen'); } catch (_) {}
      window.setTimeout(() => popup.querySelector('input[type="email"]')?.focus(), 80);
    };

    popup.querySelectorAll('[data-laia-popup-close]').forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) close(); });
    window.setTimeout(open, Number(popup.dataset.delay || 0));
  };

  const initAll = (root = document) => root.querySelectorAll('[data-laia-newsletter-popup]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
